<template>
    <AdminLayout>
        <div class="text-end">
            <button @click="addNewEvent" type="button" class="btn btn-sm btn-success"> + Add Event</button>
        </div>
        <div class="table-responsive">
            <form v-on:submit.prevent="search">

                <table class="table align-middle">
                    <thead>
                        <tr>
                            <th class="text-center"></th>
                            <th class="text-center">Name</th>
                            <th class="text-center">Description</th>
                            <th class="text-center">Winners</th>
                        </tr>
                        <tr>
                            <th></th>
                            <th>
                                <input v-model="eventsSearchObj.name" class="form-control" />
                            </th>
                            <th>
                                <input v-model="eventsSearchObj.description" class="form-control" />
                                <button type="submit" class="d-none" />
                            </th>
                            <th>
                                <input v-model="eventsSearchObj.numberWinners" class="form-control" />
                            </th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr style="cursor: pointer;" @click.prevent="getContestInfo(evnt.id)" v-for="evnt in events"
                            :key="evnt.id">
                            <td><button type="button" @click.stop.prevent="initializeEvent(evnt.id)"
                                    class="btn btn-sm btn-secondary">
                                    <i class="bi bi-arrow-clockwise"></i>
                                </button></td>
                            <td>{{ evnt.name }}</td>
                            <td>{{ evnt.description }}</td>
                            <td>{{ evnt.numberWinners }}</td>
                            <td><button type="button" class="btn btn-sm btn-danger"
                                    @click.stop.prevent="deleteEvent(evnt.id)">
                                    <i class="bi bi-trash"></i>
                                </button></td>
                        </tr>
                    </tbody>
                </table>
            </form>

        </div>
        <FullScreenModal title="Contest Information" @close="toggleModal" :show="showModal">
            <EventInfo :id="selectedId" @next="handleNext" @prev="handlePrev" @reset="onReset" />
        </FullScreenModal>
    </AdminLayout>
</template>

<script setup>
import EventInfo from '@/components/events/EventInfo.vue';
import FullScreenModal from '@/components/modals/FullScreenModal.vue';
import AdminLayout from '@/layouts/AdminLayout.vue';
import confirmationService from '@/services/confirmationService';
import eventService from '@/services/eventService';
import spinnerService from '@/services/spinnerService';
import toastService from '@/services/toastService';
import { onMounted, ref } from 'vue';

const events = ref([]);
const eventsSearchObj = ref({});
const selectedId = ref('');
const showModal = ref(false);
const currentIndex = ref(-1);
const getContestInfo = async (id) => {
    selectedId.value = id;
    toggleModal();
}

const initializeEvent = async (id) => {
    const confirmed = await confirmationService.show('Are you sure you want to reset scores?');
    if (!confirmed)
        return;
    const resp = await eventService.resetScores(id);
    if (resp.success) {
        toastService.success("Event scores cleared successfully!");
    }
    else {
        toastService.error(resp.message);
    }
}

const onReset = () => {
    selectedId.value = '';
    currentIndex.value = -1;
};
const handleNext = () => {
    if (currentIndex.value < events.value.length - 1) {
        currentIndex.value += 1;
        selectedId.value = events.value[currentIndex.value].id;
    }
};
const handlePrev = () => {
    if (currentIndex.value > 0) {
        currentIndex.value -= 1;
        selectedId.value = events.value[currentIndex.value].id;
    }
};

const addNewEvent = () => {
    selectedId.value = '00000000-0000-0000-0000-000000000000';
    toggleModal();
}

const toggleModal = () => {
    showModal.value = !showModal.value;
    if (!showModal.value)
        onReset();
};
const search = async () => {
    events.value = await eventService.search(eventsSearchObj.value);
}

const deleteEvent = async (id) => {
    const confirmed = await confirmationService.show("Deleting an event will delete all scores would you like to continue?");
    if (!confirmed) return;
    spinnerService.show();
    const response = await eventService.deleteEvent(id);
    if (response.success) {
        toastService.success("Event deleted successfully!");
        search();
    }
    else {
        toastService.error(response.message);
    }
    spinnerService.hide();
}

onMounted(() => {
    search();
});

</script>